import { Products } from "../Model/Products";
import { ProductRepository } from "../Repository/ProductRepository";



export interface UpdateTableProductUseCase {
    invoke: (data: Products) => Promise<boolean>;
  }
  
  export class UpdateTableProduct implements UpdateTableProductUseCase {
    private productRepo: ProductRepository;
    constructor(_ProductRepo: ProductRepository) {
      this.productRepo = _ProductRepo;
    }
  
    async invoke(data: Products){
       
        if(!data){
            throw new Error(
                "Your todo should have at leat 2 characters."
              );
        }
         
        const update  = await this.productRepo.updateTableProduct(data);
        return update;
    }
  }